import {ActivatedRouteSnapshot, CanDeactivate, GuardResult, MaybeAsync, RouterStateSnapshot} from '@angular/router';

export class CanDeactivateGuard implements CanDeactivate<CanDeactivate<any>> {

    public canDeactivate(
        component: CanDeactivate<any>,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): MaybeAsync<GuardResult> {
        return component && component.canDeactivate
            ? component.canDeactivate(
                component,
                currentRoute,
                currentState,
                nextState
            )
            : true;
    }

}
